import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { usePackages } from 'lib/hooks/queries/packages/usePackages';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import PackageModal from './components/PackageModal';
import { defaultColumns, defaultFilters } from './lib/helpers';

const Packages = () => {
  return (
    <AgTablePage
      ModalComponent={PackageModal}
      defaultColumns={defaultColumns}
      defaultFilters={defaultFilters}
      useData={usePackages}
      name="packages"
      queryOptions={{
        select: (data) => ({
          ...data,
          packages: data.packages.map((pack) => ({
            ...pack,
            products: pack.products.map((prod) => ({ ...prod, label: prod.name })),
            procedures: pack.procedures.map((procedure) => ({
              ...procedure,
              label: procedure.name
            }))
          }))
        })
      }}
    />
  );
};

export default Packages;
